module.exports = __webpack_public_path__ + "media/images/home/flipcard_company_blue-3d760499822aafc029d1c741ee6284d1.png";